import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'form-ui-switch',
  templateUrl: './form-ui-switch.component.html',
  styleUrls: ['./form-ui-switch.component.scss']
})
export class FormUiSwitchComponent implements OnInit {

  @Input() value = false;
  @Input() title = '';
  @Output() valueChange = new EventEmitter<boolean>()
  
  form: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      switchName: this.fb.array([])
    });
  }

  onChange(isChecked: boolean) {
    // console.log('isChecked', isChecked);
    this.valueChange.emit(isChecked);
  }


}
